import { mutate } from "swr";

import * as fetcher from "../fetcher";

export const associateDrawing = async (
  opportunityId: string,
  designId: string,
  applicationId?: string
) => {
  const res = await fetcher.opportunity.post<null, true>(
    `/${opportunityId}/designs`,
    {
      designId,
      applicationId,
    },
    undefined,
    true
  );

  mutate(`/opportunities/${opportunityId}`);
  mutate(`/opportunities/${opportunityId}/history`);

  return res;
};

export const disassociateDrawing = async (
  opportunityId: string,
  designId: string
) => {
  const res = await fetcher.opportunity.remove(
    `/${opportunityId}/designs/${designId}`
  );

  if (res.status < 300) {
    mutate(`/opportunities/${opportunityId}`);
    mutate(`/opportunities/${opportunityId}/history`);
  }

  return res;
};
